import { infoRows, relatedNotes, seriesTitle } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Info() {
  return (
    <section id="info" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="观影信息"
            title="速览：这是一部怎样的作品"
            desc="在开始观看或重温之前，先用一张表快速了解它的题材、叙事风格与适合人群。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid lg:grid-cols-2 gap-6 lg:gap-10">
          <Reveal delay={60}>
            <div className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
              <dl className="divide-y divide-background-200">
                {infoRows.map((row) => (
                  <div key={row.label} className="flex items-center gap-4 px-5 py-4">
                    <dt className="w-24 shrink-0 text-xs md:text-sm text-foreground-500 font-label">
                      {row.label}
                    </dt>
                    <dd className="text-xs md:text-sm text-foreground-900 font-medium">{row.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="h-full flex flex-col rounded-lg bg-background-100 border border-background-200 overflow-hidden">
              <div className="w-full h-44 md:h-52 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=warm%20moody%20cinematic%20interior%20corner%20with%20soft%20amber%20lamp%20light%2C%20draped%20curtains%20and%20quiet%20empty%20space%2C%20muted%20terracotta%20and%20cream%20tones%2C%20artistic%20film%20texture%2C%20intimate%20contemplative%20atmosphere%2C%20no%20people&width=1200&height=700&seq=ssl-info-band&orientation=landscape"
                  alt="善良的嫂子题材氛围示意"
                  title="善良的嫂子 题材与氛围"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 flex items-center gap-2">
                  <i className="ri-stack-line text-secondary-600"></i> {seriesTitle}
                </h3>
                <ul className="mt-4 space-y-3">
                  {relatedNotes.map((note) => (
                    <li key={note.slice(0, 10)} className="flex items-start gap-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0"></i>
                      <span>{note}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}